// extracted by mini-css-extract-plugin
export default {"list":"BankEmployeeList_list__bdZPV","listItem":"BankEmployeeList_listItem__pEeor","listItemSelected":"BankEmployeeList_listItemSelected__LUHaY"};